import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../theme/getTheme';

export type CouponRedeemModalStylePack = {
  styles: ReturnType<typeof buildStyles>;
  closeIconColor: string;
  placeholderTextColor: string;
};

const buildStyles = (theme: Theme) =>
  StyleSheet.create({
    contentWrap: {
      width: '100%',
      maxWidth: 400,
      paddingHorizontal: 16,
    },
    modalContainer: {
      padding: 32,
      borderRadius: 24,
      maxWidth: 400,
      width: '100%',
      backgroundColor: theme.background.card,
      overflow: 'hidden',
    },
    closeButton: {
      position: 'absolute',
      top: 14,
      right: 14,
      padding: 8,
      zIndex: 10,
    },
    heroImage: {
      width: '100%',
      height: 168,
      marginBottom: 8,
      alignSelf: 'center',
    },
    header: {
      alignItems: 'center',
      paddingBottom: 20,
    },
    title: {
      fontSize: 22,
      fontWeight: '700',
      color: theme.black,
      textAlign: 'center',
      letterSpacing: 0.2,
    },
    subtitle: {
      color: theme.gray[500],
      fontSize: 14,
      marginTop: 10,
      textAlign: 'center',
      paddingHorizontal: 4,
      lineHeight: 20,
    },
    input: {
      borderWidth: 1.5,
      borderColor: theme.primary,
      borderRadius: 12,
      paddingHorizontal: 16,
      paddingVertical: 14,
      fontSize: 16,
      fontFamily: Platform.select({ ios: 'Menlo', android: 'monospace', default: 'monospace' }),
      color: theme.black,
      backgroundColor: theme.background.cardElevated,
    },
    hint: {
      fontSize: 12,
      color: theme.gray[500],
      marginTop: 10,
      textAlign: 'center',
    },
    errorText: {
      fontSize: 13,
      color: theme.error,
      marginTop: 10,
      textAlign: 'center',
    },
    redeemButtonOuter: {
      marginTop: 28,
      borderRadius: 9999,
      overflow: 'hidden',
      width: '100%',
    },
    redeemButtonGradient: {
      paddingVertical: 16,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 9999,
    },
    redeemButtonPressed: {
      opacity: 0.88,
    },
    redeemButtonDisabled: {
      opacity: 0.45,
    },
    redeemButtonText: {
      color: theme.white,
      fontWeight: '700',
      fontSize: 16,
      letterSpacing: 0.3,
    },
    successBlock: {
      alignItems: 'center',
      paddingVertical: 8,
    },
    successCoinRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    successCoinImage: {
      width: 44,
      height: 44,
    },
    successCheck: {
      marginTop: 8,
    },
    successAmount: {
      fontSize: 36,
      fontWeight: '800',
      color: theme.black,
    },
    successLabel: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.success,
      marginTop: 12,
      textAlign: 'center',
    },
    doneButton: {
      marginTop: 24,
      backgroundColor: theme.background.cardElevated,
      borderRadius: 9999,
      paddingVertical: 14,
      alignItems: 'center',
      width: '100%',
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    doneButtonText: {
      fontWeight: '700',
      fontSize: 15,
      color: theme.black,
    },
  });

export const getCouponRedeemModalStylePack = (theme: Theme): CouponRedeemModalStylePack => ({
  styles: buildStyles(theme),
  closeIconColor: theme.gray[600],
  placeholderTextColor: theme.gray[500],
});
